import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import BackButtom from "../../../../components/backButton";
import DataGrid, { ItemField } from "../../../../components/datagrid";
import Icons from "../../../../components/icons-helper";
import ButtonRound from "../../../../components/button-action";

import {
  CardWrapper,
  Wrapper,
  ConfirmDialogStyled,
} from "./styles";
import { theme } from "../../../../styles/theme";
import { ContainerButtonActions } from "../../companies/list/styles";
import { IssModel, IssResponseModel } from "../../../../../domain/models/iss";
import { Link } from "../../../../components/cards/navigate-card/styles";
import Icon from "../../../../components/icon";
import { Filters } from "./filters";
import { FilterType } from "./type";

type PageProps = {
  list?: IssResponseModel;
  loading?: boolean;
  handleReload: (filters: FilterType) => void;
  handleDelete: (id: number) => void;
};

const IssListPage: React.FC<PageProps> = ({
  list,
  loading,
  handleReload,
  handleDelete,
}) => {
  const history = useHistory();
  const [remove, setRemove] = useState<IssModel | undefined>();

  const fields: ItemField[] = [
    {
      title: "Cidade (IBGE)",
      key: "cityIbgeCode",
      renderItem: (data: IssModel) => data.cityIbgeCode || "-",
    },
    {
      title: "Serviço Nacional",
      key: "nationalService",
      renderItem: (data: IssModel) => data.nationalService?.description || "-",
    },
    {
      title: "Alíquota (%)",
      key: "aliquot",
      renderItem: (data: IssModel) => data.aliquot ? `${data.aliquot.toFixed(2)}%` : "-",
    },
    {
      title: "Ações",
      key: "actions",
      renderItem: (data: IssModel) => (
        <ContainerButtonActions>
          <ButtonRound
            backgroundColor={theme.colors.darkBlue}
            onClick={() => history.push(`/admin/iss/${data?.id}?edit=true`)}
            title="Editar"
            color={theme.colors.lightBlue}
          >
            <Icons
              height={15}
              width={15}
              name="edit"
              color={theme.colors.primary}
            />
          </ButtonRound>
          <ButtonRound
            backgroundColor={theme.colors.darkBlue}
            onClick={() => {
              setRemove(data);
            }}
            title="Excluir"
            color={theme.colors.red}
          >
            <Icons
              height={15}
              width={15}
              name="trash"
              color={theme.colors.red}
            />
          </ButtonRound>
        </ContainerButtonActions>
      ),
    },
  ];

  return (
    <Wrapper>
      <BackButtom text="Gerenciamento de ISS" />
      <CardWrapper>
        <Filters onChange={handleReload} />
        <Link className="button-create" to="/admin/iss/new" invertColor={false}>
          Novo ISS <Icon name="arrow-right" />
        </Link>
      </CardWrapper>
      <DataGrid
        loading={!!loading}
        fields={fields}
        data={list?.content || []}
        totalPages={list?.totalPages || 0}
        changePage={(page) => {
          handleReload({ page });
        }}
      />
      <ConfirmDialogStyled
        visible={!!remove}
        onHide={() => setRemove(undefined)}
        header="Confirmar exclusão"
        message="Tem certeza que deseja excluir esta configuração de ISS?"
        className="confirm-custom-dialog"
        acceptLabel="Sim"
        rejectLabel="Não"
        accept={async () => {
          if (remove?.id) {
            handleDelete(remove.id);
            setRemove(undefined);
          }
        }}
        reject={() => setRemove(undefined)}
      />
    </Wrapper>
  );
};

export default IssListPage;
